export const testeoModel = {
  te: null,
  ct: null,
  nt: null,
  dt: null,
  lt: [],
  st: false,
  gc: true,
};
